<template>

    <div class="card orange lighten-3">
      <div class="card-content">
        <h3 class="card-title">Amministratori del gruppo</h3>
        <div class="row">
          <div
              v-for="admin in adminsPersons"
              :key="admin.id"
              class="col s12 m8 offset-m2 l4">
            <div class="card white">
              <div class="card-image">
                <img :src="profileImage(admin.image_profile)" :alt="'Foto di ' + admin.id "/>
              </div>
              <div class="card-content">
                <div class="card-title">
                  <h5 v-html="getTitleName(admin.id)" />
                  <h5 class="card-title" v-if="admin.person_id > 0">{{ admin.surname }} {{ admin.name }}</h5>
                  <h5 class="card-title" v-else>Non assegnato</h5>
                </div>
              </div>
              <div class="card-action">
                <button
                    v-if="admin.person_id > 0 && admin.id !== 'owner_id'"
                    class="btn red"
                    @click="askRemoveRole(admin.id)"
                ><i class="material-icons right">delete</i>Rimuovi</button>
                <button
                    @click="askChangeRole(admin.id)"
                    class="btn green"
                ><i class="material-icons right">edit</i>Cambia</button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal modal-fixed-footer" id="select_person">
          <div class="modal-content">
          <h3 class="card-title">Seleziona persona con cui sostituire il <span>{{getTitleName(changeRoleCommand)}}</span></h3>
            <GroupSelectperson
              :persons="persons"
              :admins="admins"
              @change="selectThisPerson"
              />
          </div>
          <div class="modal-footer rowed-content">
            <div class="container-fluid">
            <div class="row">
              <div class="col s2 m3">
                <button class="btn red" @click="cancelChange()">
                  <i class="material-icons">cancel</i>
                  <span class="hide-on-small-and-down">Annulla</span>
                </button>
              </div>
              <div class="col s8 m6">
                <div class="input-field input-outlined"
                     v-if="selectedPerson !== null">
                  <label class="active" for="new_admin_role">Nuovo&nbsp;<span>{{getTitleName(changeRoleCommand)}}</span></label>
                  <input id="new_admin_role"
                         disabled
                         type="text"
                         :value="selectedPerson.surname + ' ' + selectedPerson.name"
                  />
                </div>
              </div>
              <div
                  class="col s2 m3"
                  v-if="selectedPerson !== null">
                <button class="btn green" @click="changeRole({personId: selectedPerson.person_id, userId: selectedPerson.user_id})">
                  <i v-if="saving" class="material-icons left">cloud</i>
                  <i class="material-icons">save</i>
                  <span class="hide-on-small-and-down">Salva</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>


        <div class="modal modal-fixed-footer" id="remove_role_confirmation">
          <div class="modal-content">
            <h3 class="card-title">Conferma rimozione <span>{{getTitleName(changeRoleCommand)}}</span></h3>
            <p>Vuoi davvero rimuovere questa persona dal ruolo di <span>{{getTitleName(changeRoleCommand)}}</span>?</p>
          </div>
          <div class="modal-footer">
            <button class="btn red" @click="cancelRemove()">
              <i class="material-icons">cancel</i>
              <span class="hide-on-small-and-down">Annulla</span>
            </button>
            <button class="btn green" @click="removeRole()">
              <i v-if="saving" class="material-icons left">cloud</i>
              <i class="material-icons">save</i>
              <span class="hide-on-small-and-down">Rimuovi</span>
            </button>

          </div>
        </div>

      </div>
    </div>

</template>

<script>

import Vue from 'vue';
import axios from 'axios';
import adaptProfileImage from './../../vue/mixins/adaptProfileImage.js';

export default {
  name: "GroupPersons",
  props: {
    groupId: {
      required: true,
      type: Number
    },
    createEnabled: {
      required: true,
      type: Boolean,
    },
    groupData: {
      required: true,
      type: Object
    },
    persons: {
      required: true,
      type: Array
    },
    admins: {
      required: true,
      type: Array
    },
    fields: {
      required: true,
      type: Array
    }
  },

  data: () => {
    return {
      edit: 0,
      newPersonModal: false,
      changeRoleCommand: null,

      saving: false,
      selectedPerson: null
    }
  },

  methods: {
    profileImage: function (image) {
      if (image === '') {
        return '/media/com_asdgest/images/placeholder/profile.png';
      }
      const returned = adaptProfileImage(image);
      return returned !== '' ? returned : '/media/com_asdgest/images/placeholder/profile.png';
    },

    getTitleName: function (role) {
      switch(role){
        case 'owner_id':
          return 'Presidente';
        case 'sec_1_id':
          return 'Segretario 1';
        case 'sec_2_id':
          return 'Segretario 2';
        default:
          return 'Segretario';
      }
    },

    askChangeRole: function(role) {
      if (!['sec_1_id','owner_id','sec_2_id'].includes(role)) {
        console.log('Ma tu si pazz', role);
        return;
      }
      this.changeRoleCommand = role;
      let modal = document.getElementById('select_person');
      if (!modal) {
        console.log('No modal detected');
        return;
      }
      let modalM = M.Modal.getInstance(modal);
      modalM.open();
    },

    changeRole: function({personId, userId}) {
      console.log('CHANGE ROLE',personId, userId, this.changeRoleCommand, this.selectedPerson);

      this.saving = true;

      let data = new FormData();
      data.append('task', 'register.group');
      data.append(this.changeRoleCommand.replace('_id',''), personId);
      data.append('group_id',this.groupData.group_id);

      axios({
        method: 'post',
        url: 'index.php?option=com_asdgest&view=group&format=json',
        data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
        .then( response => {
          this.saving = false;
          this.closeModal('select_person');

          if ( response.data.code === 200 ) {
            console.log('HURRA!', response)
            this.$emit('refresh');
          } else {
            alert('Modifica non salvata. Contattare admin@ucis.org');
            console.log('Qualcosa non va...', response);
          }
        })
        .catch( console.log );

      this.changeRoleCommand = null;
    },

    selectThisPerson: function ({personId, userId}) {
      for (let person of this.persons) {
        if (person.person_id === personId) {
          this.selectedPerson = person;
        }
      }
    },

    askRemoveRole: function(role) {
      if (!['sec_1_id','owner_id','sec_2_id'].includes(role)) {
        console.log('Ma tu si pazz', role);
        return;
      }
      this.changeRoleCommand = role;
      let modal = document.getElementById('remove_role_confirmation');
      if (!modal) {
        console.log('No modal detected');
        return;
      }
      let modalM = M.Modal.getInstance(modal);
      modalM.open();
    },

    removeRole: function() {
      console.log('REMOVE ROLE', this.changeRoleCommand);

      this.saving = true;

      let data = new FormData();
      data.append('task', 'register.group');
      data.append(this.changeRoleCommand.replace('_id',''), -42);
      data.append('group_id',this.groupData.group_id);

      axios({
        method: 'post',
        url: 'index.php?option=com_asdgest&view=group&format=json',
        data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then( response => {
            this.saving = false;
            this.closeModal('remove_role_confirmation');

            if ( response.data.code === 200 ) {
              console.log('Hurra!', response);
              this.$emit('refresh');
            } else {
              alert('Modifica non salvata. Contattare admin@ucis.org');
              console.log('Qualcosa non va...', response);
            }
          })
          .catch( error => {
            console.log('Error on saving:', error);
            this.saving = false;
            alert('Modifica non salvata. Contattare admin@ucis.org');
          });

      this.changeRoleCommand = null;
    },

    cancelChange: function() {
      this.closeModal('select_person');
      this.changeRoleCommand = null;
      this.selectedPerson = null;
    },

    cancelRemove: function() {
      this.closeModal('remove_role_confirmation');
      this.changeRoleCommand = null;
    },

    closeModal: function(id) {
      let elem = document.getElementById(id);
      if (!elem) {
        console.log('Error: no element!');
        return;
      }
      const modal = M.Modal.getInstance(elem);
      modal.close();
    },
  },

  computed: {

    adminsPersons: function () {
      let ret = [];
      for (let admin of this.admins) {
        if (admin.person_id > 0) {
          const person = this.persons.find((value, i) => value.person_id === admin.person_id);
          if (person) {
            ret.push({
              ...person,
              owner: admin.id === 'owner_id',
              id: admin.id
            });
          }
        } else {
          ret.push({
            person_id: 0,
            name: '',
            surname: '',
            owner: admin.id === 'owner_id',
            profile_image: '',
            id: admin.id
          });
        }
      }
      return ret;
    }
  },

  mounted() {
    let modals = document.querySelectorAll('.modal');
    window.initMaterializeModals(modals);
  }
}
</script>

<style scoped>
</style>
